module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei3.svg";